import "../styles/MisCuestionarios.css";
import "../styles/CuestionarioHistoricos.css";
import React, { useContext } from "react";
import { Stack, Button, Typography, Box } from "@mui/material";
import { Send } from "@mui/icons-material";
import { PercentageBarLabel } from "./commons/PercentageBarLabel";
import { useTranslation } from "react-i18next";

import { MisCuestionariosContext } from "../context/MisCuestionariosContext";
import colors from "../theme/colors";

function ContinuarCuestionario() {
  const { t } = useTranslation();

  const { Continuar, cuestionarioIncompleto, NuevoCuestionario } = useContext(MisCuestionariosContext);

  return (
    <Stack
      bgcolor={colors.bgPrimaryLight}
      width={"100%"}
      padding={2}
      borderRadius={2}
      spacing={2}
      alignItems={"center"}
      justifyContent={"center"}
    >
      {cuestionarioIncompleto ? (
        <>
          <Typography textAlign={"center"} variant="tituloModal" color={colors.parrafoLight}>
            {t("misCuestionarios.textoContinuar")}
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              Continuar();
            }}
            endIcon={<Send sx={{ color: colors.textMain }} />}
            size="large"
            sx={{ width: 250 }}
          >
            {t("misCuestionarios.continuar")}
          </Button>
        </>
      )
        :
        (
          <>
            <Typography textAlign={"center"} variant="tituloModal" color={colors.parrafoLight}>
              {t("misCuestionarios.textoComenzarNuevo")}
            </Typography>
            <Button
              variant="contained"
              onClick={() => {
                NuevoCuestionario();
              }}
              endIcon={<Send sx={{ color: colors.textMain }}/>}
              size="large"
              sx={{ width: 250 }}
            >
              {t("misCuestionarios.comenzarNuevo")}
            </Button>
          </>
        )
      }

      {/* Si no hay cuestionarios incompletos se oculta la barra */}
      <Box
        flexGrow={1}
        width={"100%"}
        className={cuestionarioIncompleto ? "visible" : "invisible"}
      >
        <Typography marginTop={1} variant="parrafoLight" fontWeight={'bold'}>
          {t("misCuestionarios.progreso")}:
        </Typography>
        {cuestionarioIncompleto && (
          <PercentageBarLabel
            percentage={cuestionarioIncompleto.porcentaje} color='parrafoLight'
          />
        )}
      </Box>
    </Stack>
  );
}

export default ContinuarCuestionario;
